import styles from './ChartContainerLoader.module.scss';

interface ChartContainerProps {
    isDesktop: boolean;
}

export default function ChartContainerLoader(props: ChartContainerProps) {
    const { isDesktop } = props;

    if (isDesktop) {
        return (
            <section className={styles.chartContainer}>
                <div className={`${styles.chart} ${styles.chartSkeleton}`}>
                </div>
            </section>
        );
    }
}
